import _extends from "@swc/helpers/src/_extends.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PlainContentModuleContainer, TextContentBlock } from "@silvertours/front-entities";
import { Ui } from "@silvertours/front-shared";
export var StationsMap = function(_param) /*#__PURE__*/ {
    var content = _extends({}, _param);
    return _jsx(PlainContentModuleContainer, {
        children: /*#__PURE__*/ _jsx(TextContentBlock, {
            content: content,
            rules: {
                textStyle: {
                    style: Ui.RichTextStyle.Primary
                },
                isContainerMultiColumn: false
            }
        })
    });
};
